module.exports = function() {
  return new Worker(__webpack_public_path__ + "df31c8010579f59761cd.worker.js");
};